import React from "react";

export const ButtonSvg = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M13 19V13.6C13 13.0399 13 12.7599 12.891 12.546C12.7951 12.3578 12.6422 12.2049 12.454 12.109C12.2401 12 11.9601 12 11.4 12H8.6C8.03995 12 7.75992 12 7.54601 12.109C7.35785 12.2049 7.20487 12.3578 7.10899 12.546C7 12.7599 7 13.0399 7 13.6V19M1 5C1 6.65685 2.34315 8 4 8C5.65685 8 7 6.65685 7 5C7 6.65685 8.34315 8 10 8C11.6569 8 13 6.65685 13 5C13 6.65685 14.3431 8 16 8C17.6569 8 19 6.65685 19 5M4.2 19H15.8C16.9201 19 17.4802 19 17.908 18.782C18.2843 18.5903 18.5903 18.2843 18.782 17.908C19 17.4802 19 16.9201 19 15.8V4.2C19 3.0799 19 2.51984 18.782 2.09202C18.5903 1.71569 18.2843 1.40973 17.908 1.21799C17.4802 1 16.9201 1 15.8 1H4.2C3.0799 1 2.51984 1 2.09202 1.21799C1.71569 1.40973 1.40973 1.71569 1.21799 2.09202C1 2.51984 1 3.07989 1 4.2V15.8C1 16.9201 1 17.4802 1.21799 17.908C1.40973 18.2843 1.71569 18.5903 2.09202 18.782C2.51984 19 3.07989 19 4.2 19Z"
        stroke="#5926F0"
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13 19V13.6C13 13.0399 13 12.7599 12.891 12.546C12.7951 12.3578 12.6422 12.2049 12.454 12.109C12.2401 12 11.9601 12 11.4 12H8.6C8.03995 12 7.75992 12 7.54601 12.109C7.35785 12.2049 7.20487 12.3578 7.10899 12.546C7 12.7599 7 13.0399 7 13.6V19M1 5C1 6.65685 2.34315 8 4 8C5.65685 8 7 6.65685 7 5C7 6.65685 8.34315 8 10 8C11.6569 8 13 6.65685 13 5C13 6.65685 14.3431 8 16 8C17.6569 8 19 6.65685 19 5M4.2 19H15.8C16.9201 19 17.4802 19 17.908 18.782C18.2843 18.5903 18.5903 18.2843 18.782 17.908C19 17.4802 19 16.9201 19 15.8V4.2C19 3.0799 19 2.51984 18.782 2.09202C18.5903 1.71569 18.2843 1.40973 17.908 1.21799C17.4802 1 16.9201 1 15.8 1H4.2C3.0799 1 2.51984 1 2.09202 1.21799C1.71569 1.40973 1.40973 1.71569 1.21799 2.09202C1 2.51984 1 3.07989 1 4.2V15.8C1 16.9201 1 17.4802 1.21799 17.908C1.40973 18.2843 1.71569 18.5903 2.09202 18.782C2.51984 19 3.07989 19 4.2 19Z"
        stroke="white"
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const Icon2 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_6710_3413)">
        <path
          d="M12.2522 13.8933C11.1132 14.7208 9.74146 15.1665 8.3336 15.1665C6.92574 15.1665 5.55402 14.7208 4.41503 13.8933M11.2561 2.50788C12.5215 3.12504 13.559 4.12696 14.2199 5.37003C14.8809 6.61309 15.1313 8.0335 14.9354 9.42766M1.73188 9.42759C1.53594 8.03343 1.7864 6.61303 2.44735 5.36996C3.1083 4.12689 4.14581 3.12498 5.41119 2.50781M12.0003 8.49984C12.0003 10.5249 10.3586 12.1665 8.3336 12.1665C6.30856 12.1665 4.66693 10.5249 4.66693 8.49984C4.66693 6.47479 6.30856 4.83317 8.3336 4.83317C10.3586 4.83317 12.0003 6.47479 12.0003 8.49984Z"
          stroke="#727272"
          strokeWidth="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6710_3413">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.333496 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const InstaPayLogoWhite = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="42"
      viewBox="0 0 28 42"
      fill="none"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.608 14.0481C27.608 14.5152 27.5854 14.9776 27.5416 15.434C27.5416 15.434 27.5416 15.4401 27.5401 15.4432C27.5295 15.5554 27.5174 15.666 27.5038 15.7766C27.4902 15.8918 27.4751 16.0055 27.4585 16.1192C27.4419 16.2329 27.4238 16.3451 27.4042 16.4588C27.3845 16.571 27.3634 16.6847 27.3423 16.7968C27.3076 16.972 27.2698 17.1472 27.229 17.3208C27.1988 17.4498 27.1641 17.5774 27.1309 17.7049C27.1203 17.7448 27.1098 17.7848 27.0992 17.8263C27.0584 17.9753 27.0146 18.1244 26.9678 18.2734C26.9648 18.2826 26.9618 18.2918 26.9588 18.3026C25.1893 23.9799 19.9715 28.0961 13.804 28.0961V42.0029L6.90276 35.1824L0 28.0731V13.8499H13.804L0.0241566 0.0230472H13.0219C13.2816 0.00768242 13.5413 0 13.804 0C19.967 0 25.1833 4.11009 26.9558 9.78432C26.9618 9.80122 26.9663 9.81813 26.9724 9.83503C27.0162 9.97792 27.0584 10.1208 27.0977 10.2652C27.1113 10.3113 27.1218 10.3574 27.1339 10.4051C27.1671 10.5264 27.1988 10.6494 27.2275 10.7738C27.2698 10.9474 27.3076 11.1226 27.3423 11.2993C27.3634 11.4115 27.3845 11.5252 27.4042 11.6373C27.4238 11.751 27.4419 11.8632 27.4585 11.9769C27.4751 12.0906 27.4902 12.2043 27.5038 12.3195C27.5174 12.4301 27.5295 12.5408 27.5401 12.6529C27.5416 12.656 27.5416 12.6622 27.5416 12.6622C27.5854 13.1185 27.608 13.581 27.608 14.0481Z"
        fill="white"
      />
    </svg>
  );
};
export const InstaPayLogo = ({
  props = {},
  width,
  height,
}: {
  props?: {};
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? ""}
      height={height ?? ""}
      fill="none"
      {...props}
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M19.8042 9.90211C19.8042 10.2314 19.788 10.5573 19.7566 10.879C19.7566 10.8812 19.7566 10.8833 19.7555 10.8855C19.7479 10.9646 19.7392 11.0425 19.7295 11.1205C19.7198 11.2017 19.7089 11.2819 19.697 11.362C19.6851 11.4422 19.6721 11.5212 19.658 11.6014C19.6439 11.6804 19.6288 11.7606 19.6136 11.8396C19.5887 11.9631 19.5616 12.0866 19.5324 12.209C19.5107 12.2999 19.4858 12.3898 19.462 12.4797C19.4544 12.5079 19.4468 12.536 19.4392 12.5653C19.41 12.6703 19.3786 12.7754 19.345 12.8804C19.3429 12.8869 19.3407 12.8934 19.3385 12.901C18.0692 16.9028 14.3263 19.8042 9.90211 19.8042V29.6068L4.9516 24.7991L0 19.788V9.7624H9.90211L0.0173284 0.0162454H9.34111C9.52739 0.00541514 9.71367 0 9.90211 0C14.323 0 18.0649 2.8971 19.3364 6.89671C19.3407 6.90863 19.3439 6.92054 19.3483 6.93246C19.3797 7.03318 19.41 7.1339 19.4382 7.2357C19.4479 7.26819 19.4555 7.30068 19.4642 7.33426C19.488 7.41982 19.5107 7.50646 19.5313 7.59418C19.5616 7.71657 19.5887 7.84003 19.6136 7.96458C19.6288 8.04364 19.6439 8.12378 19.658 8.20285C19.6721 8.28299 19.6851 8.36205 19.697 8.44219C19.7089 8.52234 19.7198 8.60248 19.7295 8.68371C19.7392 8.76169 19.7479 8.83967 19.7555 8.91873C19.7566 8.92089 19.7566 8.92306 19.7566 8.92522C19.788 9.24688 19.8042 9.57287 19.8042 9.90211Z" fill="url(#paint0_radial_6168_15878)" />
      <defs>
        <radialGradient id="paint0_radial_6168_15878" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(5.00911) rotate(80.6157) scale(30.0084 180.05)">
          <stop stop-color="#E64067" />
          <stop offset="0.55653" stop-color="#5926F0" />
          <stop offset="1" stop-color="#4828A0" />
        </radialGradient>
      </defs>
    </svg>
  );
};
export const InstaPayLogo2 = ({
  props = {},
  width = 72,
  height = 72,
}: {
  props?: {};
  width?: string;
  height?: string;
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width}
      height={height}
      viewBox="0 0 72 72" fill="none"
      {...props}
    >
      <g filter="url(#filter0_d_8766_24666)">
        <path d="M4 14C4 7.37258 9.37258 2 16 2H56C62.6274 2 68 7.37258 68 14V54C68 60.6274 62.6274 66 56 66H16C9.37258 66 4 60.6274 4 54V14Z" fill="#5926F0" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M48.3271 29.7725C48.3271 30.1823 48.3069 30.5882 48.2678 30.9886C48.2678 30.9913 48.2678 30.994 48.2665 30.9967C48.257 31.0951 48.2463 31.1922 48.2341 31.2893C48.222 31.3904 48.2085 31.4901 48.1937 31.5899C48.1788 31.6897 48.1627 31.7881 48.1451 31.8879C48.1276 31.9863 48.1087 32.0861 48.0899 32.1845C48.0588 32.3382 48.0251 32.4919 47.9887 32.6443C47.9618 32.7575 47.9308 32.8694 47.9011 32.9813C47.8917 33.0164 47.8822 33.0514 47.8728 33.0878C47.8364 33.2186 47.7973 33.3494 47.7555 33.4802C47.7528 33.4883 47.7501 33.4964 47.7474 33.5058C46.1672 38.4876 41.5076 42.0996 36 42.0996V54.3028L29.8371 48.3178L23.6729 42.0794V29.5985H36L23.6944 17.4655H35.3016C35.5335 17.4521 35.7654 17.4453 36 17.4453C41.5036 17.4453 46.1618 21.0519 47.7447 26.031C47.7501 26.0459 47.7541 26.0607 47.7595 26.0755C47.7986 26.2009 47.8364 26.3263 47.8714 26.453C47.8836 26.4935 47.893 26.5339 47.9038 26.5757C47.9335 26.6822 47.9618 26.7901 47.9874 26.8993C48.0251 27.0517 48.0588 27.2054 48.0899 27.3604C48.1087 27.4588 48.1276 27.5586 48.1451 27.657C48.1627 27.7568 48.1788 27.8552 48.1937 27.955C48.2085 28.0548 48.222 28.1545 48.2341 28.2557C48.2463 28.3527 48.257 28.4498 48.2665 28.5482C48.2678 28.5509 48.2678 28.5536 48.2678 28.5563C48.3069 28.9568 48.3271 29.3626 48.3271 29.7725Z" fill="white" />
      </g>
      <defs>
        <filter id="filter0_d_8766_24666" x="0" y="0" width="72" height="72" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.28836 0 0 0 0 0.1958 0 0 0 0 0.89 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8766_24666" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8766_24666" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};
export const Cameraicon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={"21"}
      height="19"
      viewBox="0 0 21 19"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_6168_33554)">
        <path
          d="M16.8262 10.3594C18.843 10.3595 20.4775 11.9948 20.4775 14.0117C20.4772 16.0283 18.8428 17.6629 16.8262 17.6631C14.8095 17.663 13.1742 16.0284 13.1738 14.0117C13.1738 11.9948 14.8093 10.3595 16.8262 10.3594ZM16.5303 13.7139H15.2334V14.3037H16.5303V15.6006H17.1201V14.3037H18.4131V13.7139H17.1201V12.4238H16.5303V13.7139ZM16.2285 3.79004C17.1768 3.79004 17.9482 4.56144 17.9482 5.50977V9.55273C17.5292 9.42206 17.0832 9.35156 16.6211 9.35156C14.1628 9.35178 12.1701 11.3444 12.1699 13.8027C12.1699 13.9047 12.1749 14.0062 12.1816 14.1064H4.38477C3.43644 14.1064 2.66504 13.335 2.66504 12.3867V5.50977C2.66504 4.56144 3.43644 3.79004 4.38477 3.79004H16.2285ZM10.3066 6.65527C9.04273 6.65528 8.01465 7.68432 8.01465 8.94824C8.01471 10.2121 9.04276 11.2402 10.3066 11.2402C11.5705 11.2402 12.5996 10.2121 12.5996 8.94824C12.5996 7.68432 11.5706 6.65527 10.3066 6.65527ZM5.53027 6.08301C5.21421 6.08321 4.95821 6.33921 4.95801 6.65527C4.95801 6.97151 5.21408 7.22831 5.53027 7.22852H6.67676C6.99312 7.22852 7.25 6.97164 7.25 6.65527C7.2498 6.33908 6.993 6.08301 6.67676 6.08301H5.53027Z"
          fill="#5926F0"
        />
      </g>
      <defs>
        <clipPath id="clip0_6168_33554">
          <rect
            width="20.3648"
            height="18.7356"
            fill="white"
            transform="translate(0.435547 0.25)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const SwidenFlag = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="14"
      viewBox="0 0 19 14"
      fill="none"
      {...props}
    >
      <rect width="18.3303" height="13.0931" rx="2" fill="white" />
      <mask
        id="mask0_6168_33922"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="19"
        height="14"
      >
        <rect width="18.3303" height="13.0931" rx="2" fill="white" />
      </mask>
      <g mask="url(#mask0_6168_33922)">
        <rect width="18.3303" height="13.0931" fill="#FF0000" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.85592 7.85588H5.57064C5.38654 7.85588 5.2373 7.70664 5.2373 7.52255V5.5706C5.2373 5.38651 5.38654 5.23727 5.57064 5.23727H7.85592V2.95199C7.85592 2.76789 8.00516 2.61865 8.18925 2.61865H10.1412C10.3253 2.61865 10.4745 2.76789 10.4745 2.95199V5.23727H12.7598C12.9439 5.23727 13.0931 5.38651 13.0931 5.5706V7.52255C13.0931 7.70664 12.9439 7.85588 12.7598 7.85588H10.4745V10.1412C10.4745 10.3253 10.3253 10.4745 10.1412 10.4745H8.18925C8.00516 10.4745 7.85592 10.3253 7.85592 10.1412V7.85588Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
export const EmptySvg = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? "24"}
      height={props.height ?? "24"}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M20.25 12V19.5C20.25 19.8978 20.092 20.2794 19.8107 20.5607C19.5294 20.842 19.1478 21 18.75 21H4.5C4.10218 21 3.72064 20.842 3.43934 20.5607C3.15804 20.2794 3 19.8978 3 19.5V5.25C3 4.85218 3.15804 4.47064 3.43934 4.18934C3.72064 3.90804 4.10218 3.75 4.5 3.75H12C12.1989 3.75 12.3897 3.82902 12.5303 3.96967C12.671 4.11032 12.75 4.30109 12.75 4.5C12.75 4.69891 12.671 4.88968 12.5303 5.03033C12.3897 5.17098 12.1989 5.25 12 5.25H4.5V19.5H18.75V12C18.75 11.8011 18.829 11.6103 18.9697 11.4697C19.1103 11.329 19.3011 11.25 19.5 11.25C19.6989 11.25 19.8897 11.329 20.0303 11.4697C20.171 11.6103 20.25 11.8011 20.25 12ZM21.75 5.625C21.75 6.29251 21.5521 6.94503 21.1812 7.50005C20.8104 8.05507 20.2833 8.48765 19.6666 8.74309C19.0499 8.99854 18.3713 9.06538 17.7166 8.93515C17.0619 8.80493 16.4605 8.48349 15.9885 8.01149C15.5165 7.53948 15.1951 6.93812 15.0648 6.28343C14.9346 5.62874 15.0015 4.95014 15.2569 4.33344C15.5124 3.71674 15.9449 3.18964 16.5 2.81879C17.055 2.44794 17.7075 2.25 18.375 2.25C19.2701 2.25 20.1285 2.60558 20.7615 3.23851C21.3944 3.87145 21.75 4.72989 21.75 5.625ZM20.25 5.625C20.25 5.25416 20.14 4.89165 19.934 4.58331C19.728 4.27496 19.4351 4.03464 19.0925 3.89273C18.7499 3.75081 18.3729 3.71368 18.0092 3.78603C17.6455 3.85837 17.3114 4.03695 17.0492 4.29917C16.787 4.5614 16.6084 4.89549 16.536 5.25921C16.4637 5.62292 16.5008 5.99992 16.6427 6.34253C16.7846 6.68514 17.025 6.97798 17.3333 7.18401C17.6416 7.39003 18.0042 7.5 18.375 7.5C18.8723 7.5 19.3492 7.30246 19.7008 6.95083C20.0525 6.59919 20.25 6.12228 20.25 5.625Z"
        fill="#141414"
      />
    </svg>
  );
};
export const AdreesSvg = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? "24"}
      height={props.height ?? "24"}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M5.00202 10.9648C3.47055 11.6518 2.50098 12.6455 2.50098 13.7552C2.50098 15.8269 5.85988 17.5067 10.0041 17.5067C14.1483 17.5067 17.5072 15.8269 17.5072 13.7552C17.5072 12.6455 16.5377 11.6518 15.0062 10.9648"
        stroke="#555463"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.0487 14.1719C12.1452 14.7597 11.081 15.0512 10.0041 15.0056C8.92719 15.0512 7.8629 14.7597 6.95947 14.1719"
        stroke="#555463"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.8382 3.26141C12.5814 4.00459 12.8038 5.1223 12.4015 6.09333C11.9993 7.06437 11.0518 7.69751 10.0008 7.69751C8.94972 7.69751 8.00217 7.06437 7.59997 6.09333C7.19777 5.1223 7.42011 4.00459 8.16333 3.26141C8.65054 2.7739 9.31152 2.5 10.0008 2.5C10.69 2.5 11.351 2.7739 11.8382 3.26141"
        stroke="#555463"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.0042 7.69727V12.5059"
        stroke="#555463"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const PayPalLogo = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? "24"}
      height={props.height ?? "24"}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M20.0596 5.13451C19.0906 4.03012 17.3391 3.55664 15.0985 3.55664H8.59545C8.13702 3.55664 7.74747 3.89004 7.6757 4.3421L4.96797 21.5152C4.91414 21.8538 5.17634 22.1606 5.51958 22.1606H9.5343L10.5426 15.7652L10.5113 15.9654C10.5831 15.5134 10.9698 15.18 11.4276 15.18H13.3354C17.0833 15.18 20.0179 13.6577 20.8752 9.25399C20.9006 9.12375 20.9226 8.99699 20.9417 8.87312C20.8335 8.81582 20.8335 8.81582 20.9417 8.87312C21.197 7.24547 20.94 6.13761 20.0596 5.13451Z"
        fill="#27346A"
      />
      <path
        d="M12.0788 8.28678C12.1859 8.23584 12.3051 8.20748 12.4301 8.20748H17.5284C18.1321 8.20748 18.6953 8.24684 19.2099 8.32961C19.3575 8.35334 19.5005 8.38055 19.6394 8.4118C19.7783 8.44248 19.9132 8.47721 20.044 8.51541C20.1094 8.53451 20.1736 8.55419 20.2367 8.57503C20.4897 8.65954 20.7252 8.75794 20.9417 8.87312C21.197 7.2449 20.94 6.13761 20.0596 5.13451C19.0901 4.03012 17.3391 3.55664 15.0985 3.55664H8.59487C8.13702 3.55664 7.74747 3.89004 7.6757 4.3421L4.96797 21.5146C4.91414 21.8538 5.17634 22.16 5.51901 22.16H9.5343L11.6262 8.89454C11.669 8.62249 11.8438 8.39965 12.0788 8.28678Z"
        fill="#27346A"
      />
      <path
        d="M20.8757 9.25391C20.0185 13.657 17.0838 15.1799 13.3359 15.1799H11.4276C10.9697 15.1799 10.5831 15.5133 10.5119 15.9654L9.25757 23.9172C9.21068 24.2136 9.4399 24.4821 9.73973 24.4821H13.1241C13.5246 24.4821 13.8656 24.1904 13.9281 23.7951L13.9611 23.6226L14.5989 19.5801L14.64 19.3567C14.7025 18.9613 15.0435 18.6696 15.444 18.6696H15.9505C19.2289 18.6696 21.796 17.3377 22.5462 13.4857C22.8593 11.876 22.6972 10.532 21.8689 9.58789C21.6177 9.30195 21.3058 9.06579 20.9423 8.87305C20.9226 8.99749 20.9012 9.12368 20.8757 9.25391Z"
        fill="#2790C3"
      />
      <path
        d="M20.0439 8.51594C19.913 8.47774 19.7782 8.44301 19.6393 8.41233C19.5003 8.38165 19.3568 8.35445 19.2098 8.33072C18.6946 8.24737 18.132 8.20801 17.5277 8.20801H12.43C12.3044 8.20801 12.1852 8.23637 12.0787 8.28789C11.8431 8.40076 11.6689 8.62302 11.626 8.89565L10.5425 15.7657L10.5112 15.966C10.5824 15.5139 10.9691 15.1805 11.4269 15.1805H13.3353C17.0832 15.1805 20.0178 13.6582 20.875 9.25452C20.9005 9.12428 20.9219 8.9981 20.9416 8.87365C20.7245 8.75905 20.4895 8.66007 20.2366 8.57614C20.1735 8.5553 20.1093 8.53504 20.0439 8.51594Z"
        fill="#1F264F"
      />
    </svg>
  );
};
export const AppleLogo = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? "24"}
      height={props.height ?? "24"}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M20.1162 13.4896C20.1457 16.6677 22.9041 17.7252 22.9347 17.7387C22.9114 17.8132 22.4939 19.2457 21.4814 20.7254C20.6061 22.0047 19.6977 23.2793 18.2667 23.3057C16.8606 23.3316 16.4084 22.4719 14.8008 22.4719C13.1937 22.4719 12.6914 23.2793 11.3603 23.3316C9.97901 23.3839 8.92712 21.9483 8.04462 20.6737C6.24124 18.0665 4.86309 13.3063 6.7136 10.0931C7.63289 8.49747 9.27574 7.48702 11.0589 7.46111C12.4153 7.43524 13.6956 8.37366 14.5248 8.37366C15.3535 8.37366 16.9092 7.24513 18.5448 7.41087C19.2295 7.43936 21.1515 7.68745 22.3857 9.49394C22.2862 9.55558 20.0924 10.8328 20.1162 13.4896ZM17.4736 5.68597C18.2069 4.79829 18.7005 3.56256 18.5658 2.33301C17.5088 2.37549 16.2305 3.0374 15.4723 3.9246C14.7928 4.71025 14.1978 5.96773 14.3583 7.17294C15.5365 7.2641 16.7402 6.57422 17.4736 5.68597Z"
        fill="black"
      />
    </svg>
  );
};


export const WorldIcon = ({ size = 13 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 13 13"
    fill="none"
  >
    <g clip-path="url(#clip0_8278_11243)">
      <path
        d="M7.5 13.125C10.6066 13.125 13.125 10.6066 13.125 7.5C13.125 4.3934 10.6066 1.875 7.5 1.875C4.3934 1.875 1.875 4.3934 1.875 7.5C1.875 10.6066 4.3934 13.125 7.5 13.125Z"
        stroke="#111111"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.84375 7.5C9.84375 11.25 7.5 13.125 7.5 13.125C7.5 13.125 5.15625 11.25 5.15625 7.5C5.15625 3.75 7.5 1.875 7.5 1.875C7.5 1.875 9.84375 3.75 9.84375 7.5Z"
        stroke="#111111"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.19482 5.625H12.805"
        stroke="#111111"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.19482 9.375H12.805"
        stroke="#111111"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8278_11243">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const PeopeFour = ({ size = 30 }) => (

  <svg xmlns="http://www.w3.org/2000/svg" width={size}
    height={size}
    viewBox="0 0 32 32" fill="none">
    <path opacity="0.2" d="M10 25C12.2091 25 14 23.2091 14 21C14 18.7909 12.2091 17 10 17C7.79086 17 6 18.7909 6 21C6 23.2091 7.79086 25 10 25Z" fill="#A88BFF" />
    <path opacity="0.2" d="M10 4.0625C12.1746 4.0625 13.9375 5.82538 13.9375 8C13.9375 10.1746 12.1746 11.9375 10 11.9375C7.82538 11.9375 6.0625 10.1746 6.0625 8C6.0625 5.82538 7.82538 4.0625 10 4.0625Z" fill="#A88BFF" stroke="#A88BFF" stroke-width="0.125" />
    <path opacity="0.2" d="M22 17.0625C24.1746 17.0625 25.9375 18.8254 25.9375 21C25.9375 23.1746 24.1746 24.9375 22 24.9375C19.8254 24.9375 18.0625 23.1746 18.0625 21C18.0625 18.8254 19.8254 17.0625 22 17.0625Z" fill="#A88BFF" stroke="#A88BFF" stroke-width="0.125" />
    <path opacity="0.2" d="M22 12C24.2091 12 26 10.2091 26 8C26 5.79086 24.2091 4 22 4C19.7909 4 18 5.79086 18 8C18 10.2091 19.7909 12 22 12Z" fill="#A88BFF" />
    <path d="M4 28C4.6986 27.0685 5.60448 26.3125 6.6459 25.7918C7.68731 25.2711 8.83566 25 10 25C11.1643 25 12.3127 25.2711 13.3541 25.7918C14.3955 26.3125 15.3014 27.0685 16 28C16.6986 27.0685 17.6045 26.3125 18.6459 25.7918C19.6873 25.2711 20.8357 25 22 25C23.1643 25 24.3127 25.2711 25.3541 25.7918C26.3955 26.3125 27.3014 27.0685 28 28" stroke="#A88BFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M4 15C4.6986 14.0685 5.60448 13.3125 6.6459 12.7918C7.68731 12.2711 8.83566 12 10 12C11.1643 12 12.3127 12.2711 13.3541 12.7918C14.3955 13.3125 15.3014 14.0685 16 15C16.6986 14.0685 17.6045 13.3125 18.6459 12.7918C19.6873 12.2711 20.8357 12 22 12C23.1643 12 24.3127 12.2711 25.3541 12.7918C26.3955 13.3125 27.3014 14.0685 28 15" stroke="#A88BFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M10 25C12.2091 25 14 23.2091 14 21C14 18.7909 12.2091 17 10 17C7.79086 17 6 18.7909 6 21C6 23.2091 7.79086 25 10 25Z" stroke="#A88BFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M10 12C12.2091 12 14 10.2091 14 8C14 5.79086 12.2091 4 10 4C7.79086 4 6 5.79086 6 8C6 10.2091 7.79086 12 10 12Z" stroke="#A88BFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M22 25C24.2091 25 26 23.2091 26 21C26 18.7909 24.2091 17 22 17C19.7909 17 18 18.7909 18 21C18 23.2091 19.7909 25 22 25Z" stroke="#A88BFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M22 12C24.2091 12 26 10.2091 26 8C26 5.79086 24.2091 4 22 4C19.7909 4 18 5.79086 18 8C18 10.2091 19.7909 12 22 12Z" stroke="#A88BFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);
export const WhiteIconInstapay = ({ size = 25 }) => (

  <svg xmlns="http://www.w3.org/2000/svg" width={size}
    height={size} viewBox="0 0 14 21" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4458 6.7229C13.4458 6.94643 13.4348 7.16775 13.4134 7.38614C13.4134 7.38761 13.4134 7.38908 13.4127 7.39055C13.4076 7.44423 13.4017 7.49717 13.3951 7.55011C13.3884 7.60526 13.3811 7.65968 13.373 7.71409C13.3649 7.7685 13.3561 7.82218 13.3465 7.87659C13.337 7.93027 13.3267 7.98468 13.3164 8.03836C13.2995 8.12218 13.2811 8.20601 13.2612 8.2891C13.2465 8.35086 13.2296 8.41189 13.2134 8.47292C13.2083 8.49204 13.2031 8.51116 13.198 8.53101C13.1781 8.60234 13.1568 8.67366 13.134 8.74499C13.1326 8.7494 13.1311 8.75381 13.1296 8.75896C12.2678 11.4759 9.72662 13.4458 6.7229 13.4458V20.1011L3.36182 16.837L0 13.4348V6.62804H6.7229L0.0117649 0.0110296H6.34201C6.46848 0.00367653 6.59495 0 6.7229 0C9.72441 0 12.2649 1.96694 13.1281 4.68242C13.1311 4.69051 13.1333 4.6986 13.1362 4.70669C13.1576 4.77507 13.1781 4.84346 13.1973 4.91257C13.2039 4.93463 13.209 4.95669 13.2149 4.97949C13.2311 5.03758 13.2465 5.0964 13.2605 5.15596C13.2811 5.23905 13.2995 5.32288 13.3164 5.40743C13.3267 5.46111 13.337 5.51552 13.3465 5.5692C13.3561 5.62361 13.3649 5.67729 13.373 5.7317C13.3811 5.78612 13.3884 5.84053 13.3951 5.89568C13.4017 5.94862 13.4076 6.00156 13.4127 6.05524C13.4134 6.05671 13.4134 6.05818 13.4134 6.05965C13.4348 6.27804 13.4458 6.49936 13.4458 6.7229Z" fill="url(#paint0_radial_8921_24235)" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4458 6.7229C13.4458 6.94643 13.4348 7.16775 13.4134 7.38614C13.4134 7.38761 13.4134 7.38908 13.4127 7.39055C13.4076 7.44423 13.4017 7.49717 13.3951 7.55011C13.3884 7.60526 13.3811 7.65968 13.373 7.71409C13.3649 7.7685 13.3561 7.82218 13.3465 7.87659C13.337 7.93027 13.3267 7.98468 13.3164 8.03836C13.2995 8.12218 13.2811 8.20601 13.2612 8.2891C13.2465 8.35086 13.2296 8.41189 13.2134 8.47292C13.2083 8.49204 13.2031 8.51116 13.198 8.53101C13.1781 8.60234 13.1568 8.67366 13.134 8.74499C13.1326 8.7494 13.1311 8.75381 13.1296 8.75896C12.2678 11.4759 9.72662 13.4458 6.7229 13.4458V20.1011L3.36182 16.837L0 13.4348V6.62804H6.7229L0.0117649 0.0110296H6.34201C6.46848 0.00367653 6.59495 0 6.7229 0C9.72441 0 12.2649 1.96694 13.1281 4.68242C13.1311 4.69051 13.1333 4.6986 13.1362 4.70669C13.1576 4.77507 13.1781 4.84346 13.1973 4.91257C13.2039 4.93463 13.209 4.95669 13.2149 4.97949C13.2311 5.03758 13.2465 5.0964 13.2605 5.15596C13.2811 5.23905 13.2995 5.32288 13.3164 5.40743C13.3267 5.46111 13.337 5.51552 13.3465 5.5692C13.3561 5.62361 13.3649 5.67729 13.373 5.7317C13.3811 5.78612 13.3884 5.84053 13.3951 5.89568C13.4017 5.94862 13.4076 6.00156 13.4127 6.05524C13.4134 6.05671 13.4134 6.05818 13.4134 6.05965C13.4348 6.27804 13.4458 6.49936 13.4458 6.7229Z" fill="#5926F0" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4458 6.7229C13.4458 6.94643 13.4348 7.16775 13.4134 7.38614C13.4134 7.38761 13.4134 7.38908 13.4127 7.39055C13.4076 7.44423 13.4017 7.49717 13.3951 7.55011C13.3884 7.60526 13.3811 7.65968 13.373 7.71409C13.3649 7.7685 13.3561 7.82218 13.3465 7.87659C13.337 7.93027 13.3267 7.98468 13.3164 8.03836C13.2995 8.12218 13.2811 8.20601 13.2612 8.2891C13.2465 8.35086 13.2296 8.41189 13.2134 8.47292C13.2083 8.49204 13.2031 8.51116 13.198 8.53101C13.1781 8.60234 13.1568 8.67366 13.134 8.74499C13.1326 8.7494 13.1311 8.75381 13.1296 8.75896C12.2678 11.4759 9.72662 13.4458 6.7229 13.4458V20.1011L3.36182 16.837L0 13.4348V6.62804H6.7229L0.0117649 0.0110296H6.34201C6.46848 0.00367653 6.59495 0 6.7229 0C9.72441 0 12.2649 1.96694 13.1281 4.68242C13.1311 4.69051 13.1333 4.6986 13.1362 4.70669C13.1576 4.77507 13.1781 4.84346 13.1973 4.91257C13.2039 4.93463 13.209 4.95669 13.2149 4.97949C13.2311 5.03758 13.2465 5.0964 13.2605 5.15596C13.2811 5.23905 13.2995 5.32288 13.3164 5.40743C13.3267 5.46111 13.337 5.51552 13.3465 5.5692C13.3561 5.62361 13.3649 5.67729 13.373 5.7317C13.3811 5.78612 13.3884 5.84053 13.3951 5.89568C13.4017 5.94862 13.4076 6.00156 13.4127 6.05524C13.4134 6.05671 13.4134 6.05818 13.4134 6.05965C13.4348 6.27804 13.4458 6.49936 13.4458 6.7229Z" fill="white" />
    <defs>
      <radialGradient id="paint0_radial_8921_24235" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(3.40086) rotate(80.6157) scale(20.3737 122.242)">
        <stop stop-color="#E64067" />
        <stop offset="0.55653" stop-color="#5926F0" />
        <stop offset="1" stop-color="#4828A0" />
      </radialGradient>
    </defs>
  </svg>
);
